import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const IconQuarterCircle = ({ style, color = 'black' }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8705_142)">
          <path
            d="M6.00024 2.25261C8.20938 2.25261 10.0002 4.04347 10.0002 6.25261C10.0002 8.46175 8.20938 10.2526 6.00024 10.2526C3.79111 10.2526 2.00024 8.46175 2.00024 6.25261C2.00024 4.04347 3.79111 2.25261 6.00024 2.25261Z"
            stroke={color}
          />
          <mask id="path-2-inside-1_8705_142" fill="white">
            <path d="M6.00018 3.06504C6.41869 3.06504 6.83325 3.1471 7.21991 3.30722C7.60663 3.46741 7.9581 3.70265 8.25409 3.99863C8.55008 4.29462 8.78531 4.64608 8.9455 5.03281C9.10563 5.41948 9.18768 5.83402 9.18768 6.25254H6.00018V3.06504Z" />
          </mask>
          <path
            d="M6.00018 3.06504C6.41869 3.06504 6.83325 3.1471 7.21991 3.30722C7.60663 3.46741 7.9581 3.70265 8.25409 3.99863C8.55008 4.29462 8.78531 4.64608 8.9455 5.03281C9.10563 5.41948 9.18768 5.83402 9.18768 6.25254H6.00018V3.06504Z"
            fill={color}
          />
          <path
            d="M6.00018 3.06504L6.00018 2.4211H5.35624V3.06504H6.00018ZM7.21991 3.30722L7.46633 2.7123L7.46628 2.71228L7.21991 3.30722ZM8.25409 3.99863L8.70942 3.5433L8.70942 3.54329L8.25409 3.99863ZM8.9455 5.03281L9.54043 4.78642L9.54042 4.78638L8.9455 5.03281ZM9.18768 6.25254V6.89648H9.83163L9.83162 6.25253L9.18768 6.25254ZM6.00018 6.25254H5.35624V6.89648H6.00018V6.25254ZM6.00018 3.06504L6.00018 3.70898C6.33453 3.70898 6.66535 3.77454 6.97354 3.90217L7.21991 3.30722L7.46628 2.71228C7.00115 2.51966 6.50284 2.4211 6.00018 2.4211L6.00018 3.06504ZM7.21991 3.30722L6.97348 3.90215C7.28176 4.02984 7.56232 4.21754 7.79876 4.45397L8.25409 3.99863L8.70942 3.54329C8.35388 3.18777 7.9315 2.90498 7.46633 2.7123L7.21991 3.30722ZM8.25409 3.99863L7.79876 4.45396C8.03519 4.6904 8.22287 4.97094 8.35057 5.27923L8.9455 5.03281L9.54042 4.78638C9.34774 4.32121 9.06497 3.89884 8.70942 3.5433L8.25409 3.99863ZM8.9455 5.03281L8.35056 5.2792C8.47818 5.58737 8.54374 5.91816 8.54374 6.25255L9.18768 6.25254L9.83162 6.25253C9.83161 5.74988 9.73308 5.25158 9.54043 4.78642L8.9455 5.03281ZM9.18768 6.25254V5.6086H6.00018V6.25254V6.89648H9.18768V6.25254ZM6.00018 6.25254H6.64412V3.06504H6.00018H5.35624V6.25254H6.00018Z"
            fill={color}
            mask="url(#path-2-inside-1_8705_142)"
          />
        </g>
        <defs>
          <clipPath id="clip0_8705_142">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
